import { FormValidators } from '@servicetitan/form-state';

export const requiredWithCustomText = (error: string) => (value: any) =>
    FormValidators.required(value) && error;

export const phoneLengthValidation = (error: string) => (value: any) =>
    value.replace(/\D/g, '').length !== 10 && error;

export const maxLengthValidation = (maxLength: number) => (value: string) =>
    value.length > maxLength && `# of characters cannot be greater than ${maxLength}.`;
